import { configureStore } from '@reduxjs/toolkit'
import screenInteractionsReducer from './screenInteractionsSlice';
import uiReducer from './uiSlice';
import developerReducer from './developerSlice';
import gameReducer from './gameSlice';

import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

export const store = configureStore({
  reducer: {
    screenInteractions: screenInteractionsReducer,
    ui: uiReducer,
    developerSandbox: developerReducer,
    game: gameReducer
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;